// LBN Load Board API equipment mapping - "Complete List" (94 types).
// Source: "LBN Equipment Code Mapping V1f.xlsx" -> sheet "Load Board API".
// Keep this list, web/src/components/sub_components/Definitions.jsx and
// dashboard/src/utils/equipmentTypes.js in sync.
export const definitions = [
  { description: "Auto Carrier", xml: {"ac":""} },
  { description: "Box Truck", xml: {"bx":""} },
  { description: "Box Truck Hazardous", xml: {"bx":{"hazmat":"true"}} },
  { description: "Box Truck Reefer", xml: {"bxr":""} },
  { description: "Box Truck Reefer w/Lift", xml: {"bxr":{"lift":"true"}} },
  { description: "Box Truck w/Lift", xml: {"bx":{"lift":"true"}} },
  { description: "B-Train", xml: {"f":{"btrain":"true"}} },
  { description: "Cargo Van", xml: {"cgv":""} },
  { description: "Conestoga Flatbed", xml: {"f":{"conestoga":"true"}} },
  { description: "Conestoga Flatbed or Stepdeck", xml: {"f":{"conestoga":"true"},"sd":{"conestoga":"true"}} },
  { description: "Conestoga Stepdeck", xml: {"sd":{"conestoga":"true"}} },
  { description: "Container", xml: {"c":""} },
  { description: "Container Insulated", xml: {"c":{"insulated":"true"}} },
  { description: "Container Refrigerated", xml: {"cr":""} },
  { description: "Conveyor", xml: {"cv":""} },
  { description: "Double Drop", xml: {"dd":""} },
  { description: "Drop Deck Landoll", xml: {"la":""} },
  { description: "Dump Trailer", xml: {"dt":""} },
  { description: "Dump Trailer Belly", xml: {"dt":{"belly":"true"}} },
  { description: "Dump Trailer End", xml: {"dt":{"end":"true"}} },
  { description: "Dump Trailer Side", xml: {"dt":{"side":"true"}} },
  { description: "Flatbed", xml: {"f":""} },
  { description: "Flatbed Air-Ride", xml: {"f":{"airride":"true"}} },
  { description: "Flatbed Double", xml: {"f":{"double":"true"}} },
  { description: "Flatbed Extendable", xml: {"f":{"extendable":"true"}} },
  { description: "Flatbed Hazardous", xml: {"f":{"hazmat":"true"}} },
  { description: "Flatbed or Step Deck", xml: {"f":"","sd":""} },
  { description: "Flatbed Overdimension", xml: {"f":{"overdimension":"true"}} },
  { description: "Flatbed w/Chains", xml: {"f":{"chains":"true"}} },
  { description: "Flatbed w/Pallet Exchange", xml: {"f":{"palletexchange":"true"}} },
  { description: "Flatbed w/Sides", xml: {"f":{"sides":"true"}} },
  { description: "Flatbed w/Tarps", xml: {"f":{"tarps":"true"}} },
  { description: "Flatbed w/Team", xml: {"f":{"team":"true"}} },
  { description: "Hopper Bottom", xml: {"hb":""} },
  { description: "Hopper High Side", xml: {"hb":{"highside":"true"}} },
  { description: "Hopper Low Side", xml: {"hb":{"lowside":"true"}} },
  { description: "Hotshot", xml: {"hs":""} },
  { description: "Hotshot Flat", xml: {"hs":{"flat":"true"}} },
  { description: "Hotshot Van", xml: {"hs":{"van":"true"}} },
  { description: "Live Bottom", xml: {"lvb":""} },
  { description: "Lowboy", xml: {"lb":""} },
  { description: "Lowboy or Removable Gooseneck", xml: {"lb":"","rg":""} },
  { description: "Lowboy Overdimension", xml: {"lb":{"overdimension":"true"}} },
  { description: "Maxi", xml: {"f":{"maxi":"true"}} },
  { description: "Moving Van", xml: {"mv":""} },
  { description: "Other", xml: {"other":""} },
  { description: "Pneumatic", xml: {"nu":""} },
  { description: "Power Only", xml: {"po":""} },
  { description: "Power Only Load Out", xml: {"po":{"loadout":"true"}} },
  { description: "Power Only Towaway", xml: {"po":{"towaway":"true"}} },
  { description: "Reefer", xml: {"r":""} },
  { description: "Reefer Air-Ride", xml: {"r":{"airride":"true"}} },
  { description: "Reefer Double", xml: {"r":{"double":"true"}} },
  { description: "Reefer Hazardous", xml: {"r":{"hazmat":"true"}} },
  { description: "Reefer Intermodal", xml: {"r":{"intermodal":"true"}} },
  { description: "Reefer Logistics", xml: {"r":{"logistics":"true"}} },
  { description: "Reefer or Van Insulated", xml: {"r":"","v":{"insulated":"true"}} },
  { description: "Reefer or Vented Van", xml: {"r":"","v":{"vented":"true"}} },
  { description: "Reefer w/Pallet Exchange", xml: {"r":{"palletexchange":"true"}} },
  { description: "Reefer w/Team", xml: {"r":{"team":"true"}} },
  { description: "Removable Gooseneck", xml: {"rg":""} },
  { description: "Sprinter Van", xml: {"sv":""} },
  { description: "Sprinter Van Hazardous", xml: {"sv":{"hazmat":"true"}} },
  { description: "Sprinter Van w/Team", xml: {"sv":{"team":"true"}} },
  { description: "Sprinter Van w/Temp Control", xml: {"sv":{"tempcontrol":"true"}} },
  { description: "Step Deck", xml: {"sd":""} },
  { description: "Step Deck or RGN", xml: {"sd":"","rg":""} },
  { description: "Tanker", xml: {"t":""} },
  { description: "Tanker Aluminum", xml: {"t":{"aluminum":"true"}} },
  { description: "Tanker Chemical", xml: {"t":{"chemical":"true"}} },
  { description: "Tanker Intermodal", xml: {"t":{"intermodal":"true"}} },
  { description: "Tanker Liquid", xml: {"t":{"liquid":"true"}} },
  { description: "Tanker Steel", xml: {"t":{"steel":"true"}} },
  { description: "Van", xml: {"v":""} },
  { description: "Van Air-Ride", xml: {"v":{"airride":"true"}} },
  { description: "Van Double", xml: {"v":{"double":"true"}} },
  { description: "Van Hazardous", xml: {"v":{"hazmat":"true"}} },
  { description: "Van Insulated", xml: {"v":{"insulated":"true"}} },
  { description: "Van Intermodal", xml: {"v":{"intermodal":"true"}} },
  { description: "Van Logistics", xml: {"v":{"logistics":"true"}} },
  { description: "Van or Flatbed", xml: {"v":"","f":""} },
  { description: "Van or Flatbed w/Tarps", xml: {"v":"","f":{"tarps":"true"}} },
  { description: "Van or Reefer", xml: {"v":"","r":""} },
  { description: "Van Triple", xml: {"v":{"triple":"true"}} },
  { description: "Van Vented", xml: {"v":{"vented":"true"}} },
  { description: "Van w/Blanket Wrap", xml: {"v":{"blanketwrap":"true"}} },
  { description: "Van w/Curtains", xml: {"v":{"curtains":"true"}} },
  { description: "Van w/Lift-Gate", xml: {"v":{"lift":"true"}} },
  { description: "Van w/Open-Top", xml: {"v":{"opentop":"true"}} },
  { description: "Van w/Pallet Exchange", xml: {"v":{"palletexchange":"true"}} },
  { description: "Van w/Roller Bed", xml: {"v":{"rollerbed":"true"}} },
  { description: "Van w/Team", xml: {"v":{"team":"true"}} },
  { description: "Van/Reefer/Flatbed", xml: {"v":"","f":"","r":""} },
  { description: "Walking Floor", xml: {"wf":""} },
];
